import { transformDateValue } from 'core/js/FormUtils';
export const getPartyView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let partyList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Contact","fieldValue":transformDataValue(data.contact,"string"), "fieldType":"string"},
                            {"fieldLabel":"Contact Mobile","fieldValue":transformDataValue(data.contactmobile,"mobile"), "fieldType":"mobile"},
                            {"fieldLabel":"Drug License","fieldValue":transformDataValue(data.druglicense,"string"), "fieldType":"string"},
                            {"fieldLabel":"GST","fieldValue":transformDataValue(data.gst,"string"), "fieldType":"string"},
                            {"fieldLabel":"Status Name","fieldValue":transformDataValue(data.statusname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Status","fieldValue":transformDataValue(data.status,"boolean"), "fieldType":"boolean"},
                            {"fieldLabel":"Rejection Reason","fieldValue":transformDataValue(data.rejectionreason,"string"), "fieldType":"string"},
                            {"fieldLabel":"Order Value","fieldValue":transformDataValue(data.ordervalue,"double"), "fieldType":"double"},
                            {"fieldLabel":"Business Id","fieldValue":transformDataValue(data.businessid,"ID"), "fieldType":"ID"},
              
              
            ],
            'dataList': [
                              {"fieldLabel":"Address","fieldValue":transformDataValue(data.address,"string"), "fieldType":"string"},
              
              ]
          }

          partyList.push(card);
  })
  return partyList;
}